import { Card, Link } from '@printdeal/ui-library';
import React from 'react';
import { dispatchDataLayerEntry } from '../../../helpers/dataLayerHelpers/productDataLayerHelper';

interface Props {
  products: {
    title: string;
    image?: string;
    slug: string;
  }[];
}

export const RelatedProducts = ({ products }: Props) => (
  <div className="pd-ml-11 pd-grid pd-grid-cols-4 pd-gap-4">
    {products.map((product) => (
      <Card
        key={product.slug}
        variant="square"
        image={<img src={product.image} alt={product.title} />}
        title={<p className="pd-text-sm">{product.title}</p>}
        link={(
          <Link
            className="pd-text-black"
            href={product.slug}
            onClick={() => {
              dispatchDataLayerEntry(
                'click_on_related_product',
                'click',
                {
                  experiment: 'EXP1530',
                  slug: product.slug,
                  title: product.title,
                },
              );
            }}
          />
        )}
      />
    ))}
  </div>
);
